import axios from 'axios';
import { formatFirmNameForEndpoints } from '@utils/generateAssetLinks';
import { Profile } from '@constants';

export const clientEndpoints = {
    fetchClient: (leadId: number, profile: Profile | null) => `/api/clients/${leadId}?profile=${profile}`,
    updateClient: (id: number) => `/api/clients/${id}`,
    sendPresentationLink: '/api/clients/send-link',
    clientLogin: '/auth/client/login',
    clientLogout: '/auth/client/logout'
}

export const fetchClientByLeadId = async ({ leadId, profile = null }) => {
    const { data } = await axios.get(clientEndpoints.fetchClient(leadId, profile));
    return data;
};
  
export const sendClientLink = async () => {
    await axios.post(clientEndpoints.sendPresentationLink);
};

export const updateClient = async (data) => {
    const { id, ...body } = data;
  
    await axios.put(clientEndpoints.updateClient(id), body);
};

export const clientLogin = async ({ leadId, email, profile, presentationType }) => {
    await axios.post(clientEndpoints.clientLogin, {leadId, email, profile: formatFirmNameForEndpoints(profile), presentationType });
};

export const clientLogout = async (leadId: number) => {
    await axios.post(clientEndpoints.clientLogout, { leadId });
};


